import { Link } from "react-router-dom"
import { Instagram, Facebook, Mail, MapPin, Phone, ShieldCheck, BadgeCheck, Lock } from "lucide-react"
import logo from "@/assets/logo-new.webp"

const Footer = () => {
  return (
    <footer className="bg-charcoal text-cream">
      {/* Trust badges row (desktop only) */}
      <div className="hidden border-b border-cream/10 md:block">
        <div className="container mx-auto flex flex-wrap items-center justify-center gap-8 px-4 py-6 text-sm text-cream/70 md:gap-12">
          <div className="flex items-center gap-2">
            <ShieldCheck className="h-5 w-5 text-trust-green" />
            <span>CE certifikat</span>
          </div>
          <div className="flex items-center gap-2">
            <BadgeCheck className="h-5 w-5 text-trust-green" />
            <span>EN71 testirano</span>
          </div>
          <div className="flex items-center gap-2">
            <Lock className="h-5 w-5 text-trust-green" />
            <span>Varno plačilo</span>
          </div>
        </div>
      </div>

      <div className="container mx-auto px-4 py-10 md:py-16">
        <div className="grid grid-cols-2 gap-8 md:gap-10 lg:grid-cols-4">
          {/* Brand */}
          <div className="col-span-2 flex flex-col items-center text-center lg:col-span-1 lg:items-start lg:text-left">
            <Link to="/" className="mb-4 flex items-center gap-2">
              <img src={logo} alt="MM Queen Magnetics" className="h-10 w-auto" width={144} height={79} />
            </Link>
            <p className="mb-6 text-sm leading-relaxed text-cream/80">
              Premium magnetne ploščice, ki spodbujajo ustvarjalnost in domišljijo.
              Gradi, zlagaj in sanjaj. Košček za koščkom.
            </p>
            <div className="flex gap-3">
              <a href="https://www.instagram.com/mmqueen.gifts/" target="_blank" rel="noopener noreferrer" className="flex h-9 w-9 items-center justify-center rounded-full bg-cream/10 transition-colors hover:bg-teal/80" aria-label="Instagram">
                <Instagram className="h-4 w-4" />
              </a>
              <a href="https://www.facebook.com/MMQueenTea" target="_blank" rel="noopener noreferrer" className="flex h-9 w-9 items-center justify-center rounded-full bg-cream/10 transition-colors hover:bg-teal/80" aria-label="Facebook">
                <Facebook className="h-4 w-4" />
              </a>
              <a href="mailto:tea@mmqueen.si" className="flex h-9 w-9 items-center justify-center rounded-full bg-cream/10 transition-colors hover:bg-teal/80" aria-label="Pošlji e-pošto">
                <Mail className="h-4 w-4" />
              </a>
            </div>
          </div>

          {/* Trgovina */}
          <div>
            <h2 className="mb-4 font-display text-sm font-semibold uppercase tracking-wider">Trgovina</h2>
            <ul className="space-y-3 text-sm text-cream/80">
              <li><Link to="/trgovina" className="transition-colors hover:text-cream">Vse ploščice</Link></li>
              <li><Link to="/trgovina?tab=kompleti" className="transition-colors hover:text-cream">Kompleti</Link></li>
              <li><Link to="/galerija" className="transition-colors hover:text-cream">Galerija</Link></li>
            </ul>
          </div>

          {/* Pomoc */}
          <div>
            <h2 className="mb-4 font-display text-sm font-semibold uppercase tracking-wider">Pomoč</h2>
            <ul className="space-y-3 text-sm text-cream/80">
              <li><Link to="/nase-ploscice" className="transition-colors hover:text-cream">Naše ploščice</Link></li>
              <li><Link to="/kontakt#faq" className="transition-colors hover:text-cream">Pogosta vprašanja</Link></li>
              <li><Link to="/kontakt" className="transition-colors hover:text-cream">Kontakt</Link></li>
              <li><Link to="/o-nas" className="transition-colors hover:text-cream">O nas</Link></li>
            </ul>
          </div>

          {/* Kontakt */}
          <div className="col-span-2 lg:col-span-1">
            <h2 className="mb-4 font-display text-sm font-semibold uppercase tracking-wider">Kontakt</h2>
            <ul className="space-y-3 text-sm text-cream/80">
              <li className="flex items-center gap-2">
                <Mail className="h-4 w-4 shrink-0 text-cream/60" />
                <a href="mailto:tea@mmqueen.si" className="transition-colors hover:text-cream">tea@mmqueen.si</a>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="h-4 w-4 shrink-0 text-cream/60" />
                <a href="tel:+38651268847" className="transition-colors hover:text-cream">051 268 847</a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-cream/60" />
                <span>Lazaret 6a, Ankaran</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-10 flex flex-col items-center justify-between gap-4 border-t border-cream/10 pt-6 text-xs text-cream/60 sm:flex-row">
          <p>&copy; {new Date().getFullYear()} MM Queen Magnetics. Vse pravice pridržane.</p>
          <div className="flex gap-6">
            <Link to="/splosni-pogoji" className="transition-colors hover:text-cream">Splošni pogoji</Link>
            <Link to="/politika-zasebnosti" className="transition-colors hover:text-cream">Zasebnost</Link>
            <Link to="/piskotki" className="transition-colors hover:text-cream">Piškotki</Link>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
